import { BaseStatusComponent } from "./status";
import { Options, Vue } from "vue-class-component";
import { ElLoading } from "element-plus";
import monitorBloc from "../../services/bloc";

@Options({
  props: {
    equipment: Object,
    type: String,
  },
})
export class DemoStatusComponent extends Vue {
  equipment: any;
  async created() {
    this.equipment.sensors = this.equipment.sensors.map((sensor) => {
      const type = [77, 78, 1];
      const last_reading = [Date.now() + 15_000, new Date(Date.now() - 15_000)];
      return {
        ...sensor,
        value: "-",
        last_reading:
          last_reading[Math.floor(Math.random() * last_reading.length)],
        alarm: false,
        message: "",
        alarm_type: type[Math.floor(Math.random() * type.length)],
        alarm_created_at: "",
      };
    });
  }

  async mounted() {
    const scope = this;
    setInterval(() => {
      scope.reading();
    }, 10000);
  }

  reading() {
    this.equipment.sensors = this.equipment.sensors.map((sensor) => {
      const type = [77, 78, 1];
      const last_reading = [Date.now() + 15_000, new Date(Date.now() - 15_000)];
      return {
        ...sensor,
        last_reading:
          last_reading[Math.floor(Math.random() * last_reading.length)],
        value: Number(Math.floor(Math.random() * 10) + 1).toFixed(2),
        alarm: false,
        message: "",
        alarm_type: type[Math.floor(Math.random() * type.length)],
        alarm_created_at: "",
      };
    });
  }

  status(last_reading: number, diff = 60) {
    return monitorBloc.isActive(last_reading, diff);
  }
}
